import 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation/dist/additional-methods.min';
import Inputmask from "inputmask/dist/inputmask.min";

class Form
{
    constructor()
    {
        this.initialize();
    }

    initialize()
    {
        let that = this;
        // Валидация
        $.validator.addMethod(
            'phone',
            function(value, element) {
                return this.optional(element) || /\s\((?!89)\d{3}\)\s\d{3}-\d{2}-\d{2}/.test(value);
            },
            'Пожалуйста, укажите номер телефона'
        );

        $.validator.methods.email = function(value, element) {
            return this.optional(element) || /^[\w%\+\-]+(\.[\w%\+\-]+)*@[\w%\+\-]+(\.[\w%\+\-]+)+$/i.test(value);
        };

        $.validator.addMethod("regex", function(value, element, regexpr) {
            return regexpr.test(value);
        });

        $.validator.addMethod("require_from_group", function(value, element, options) {
            let numberRequired = options[0];
            let selector = options[1];
            let fields = $(selector, element.form);
            let filled_fields = fields.filter(function() {
                return $(this).val() != "";
            });
            let empty_fields = fields.not(filled_fields);
            if (filled_fields.length < numberRequired && empty_fields[0] == element) {
                return false;
            }
            return true;
        }, 'Пожалуйста, заполните одно из полей');

        $('[data-bonus-validate]').validate({
            highlight: function(element) {
                let el = $(element);
                let label = el.parent().find('label');
                el.addClass("invalid");
                label.addClass("invalid");
            },
            unhighlight: function(element) {
                let el = $(element);
                let label = el.parent().find('label');
                el.removeClass("invalid");
                label.addClass("invalid");
            },
            submitHandler: function(form) {
                form.submit();
            },
            groups: {
                names: "card phone"
            },
            rules: {
                card: {
                    require_from_group: [1, "[data-bonus-card"],
                    regex: /^\d+$/,
                    minlength: 13,
                    maxlength: 13,
                    messages: {
                        regex: "Пожалуйста, введите только цифры",
                        minlength: "Пожалуйста, введите 13 символов",
                        maxlength: "Пожалуйста, введите 13 символов",
                        require_from_group: "Пожалуйста, заполните поле"
                    }
                },
                phone: {
                    require_from_group: [1, "[data-bonus-tel"],
                    regex: /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/,
                    messages: {
                        regex: 'Некорректные данные',
                        require_from_group: "Пожалуйста, заполните поле",
                    }
                }
            }
        });

        $.validator.addMethod(
            'pass',
            function(value) {
                return /^([A-Za-z0-9\d=!?~#%$&*()@'\-@._*])*$/.test(value) // consists of only these
                    // && /[a-z]/.test(value) // has a lowercase letter
                    && /[A-Z]/.test(value)
                    && /.{6,20}/.test(value)
                    && /\d/.test(value)
            },
            'Пароль должен содержать не менее 6 символов, 1 заглавную букву, 1 прописную, включать 1 цифру и не содержать русские буквы'
        );

      $.validator.addMethod(
        'passEmpty',
        function(value) {
          return /^$/.test(value)
            || (
              /^([A-Za-z0-9\d=!?~#%$&*()@'\-._])*$/.test(value)
              && /[A-Z]/.test(value)
              && /.{6,20}/.test(value)
              && /\d/.test(value)
            )
        },
        'Пароль должен содержать не менее 6 символов, 1 заглавную букву, 1 прописную, включать 1 цифру и не содержать русские буквы и пробелы'
      );

        $.validator.addMethod('notEqual', function(value, element, param) {
            return this.optional(element) || value !== $(param).val();
        }, 'Значение не должно совпадать');

        // add the rule here
        $.validator.addMethod("valueNotEquals", function(value, element, arg) {
            return arg !== value;
        }, "Значение не должно быть равным аргументу");

        // add the rule here
        $.validator.addMethod("bonusCardEqual", function(value, element, arg) {
            return (value.length >= 8 && value.length <= 13);
        }, "Введите пожалуйста  от 8 до 13 символов бонусной карты");

        $.validator.addMethod("bonusCardEqualEmpty", function(value, element, arg) {
            return /^$/.test(value) || (value.length >= 8 && value.length <= 13);
        }, "Введите пожалуйста  от 8 до 13 символов бонусной карты");

        $.validator.addMethod("validDate", function(value, element) {
            let dateNow = new Date();
            let yearNow = dateNow.getFullYear();
            let monthNow = dateNow.getMonth();
            let dayNow = dateNow.getDate();

            let year = $(element).closest('[data-select-related]').find('[data-select-year]');
            let month = $(element).closest('[data-select-related]').find('[data-select-mounth]');
            let day = $(element).closest('[data-select-related]').find('[data-select-days]');

            let res = true;

            if (year.val() != 'default') {
                if (year.val() == yearNow && month.val() - 1 == monthNow && day.val() >= dayNow) {
                    res = false;
                } else if (year.val() == yearNow && month.val() - 1 > monthNow) {
                    res = false;
                }
            }

            if (day.val() != 'default' && $(element).is('[data-select-days]')) {
                return res;
            } else {
                return true;
            }

        }, "Выбрана некоректная дата");

        $('[data-validate]').each(function() {
            let validate = $(this);
            if (validate.data('init') === 'Y') {
                return true;
            }
            validate.data('init', 'Y');

            validate.validate({
                errorClass: "invalid",
                errorElement: "label",
                highlight: function(element) {
                    let el = $(element);
                    el.closest('[data-input-wrap]').find('[data-input-label]').addClass("label-invalid");
                    el.addClass("invalid");
                    let formError = el.closest('form');
                    let elFirst = formError.find('input.invalid').eq(0);
                    if ((formError.attr('name') === 'ORDER_FORM') || formError.attr('data-cart') == '') {
                        $('html, body').animate({scrollTop: elFirst.offset().top - $('[data-header-sticky]').innerHeight() - 30 + 'px'}, 500);
                    }

                },
                unhighlight: function(element) {
                    let el = $(element);

                    el.closest('[data-input-wrap]').find('[data-input-label]').removeClass("label-invalid");
                    el.removeClass("invalid");

                },

                submitHandler: function(form, event) {
                    $('body').addClass('body--loading'); // preloader
                    if ($(form).data('ajax') === '') {
                        if ($('[data-preloader]').length > 0) {
                            $('[data-preloader]').show();
                        }
                        var xhr;
                        if (xhr && xhr.readyState !== 4) {
                            xhr.abort();
                        }
                        if ($(form).find('[data-get-virtual-card-sumbit]').length > 0) {
                            event.preventDefault();
                            $.post(
                                '/local/ajax/get_virtual_card_public.php',
                                $(form).serialize(),
                                function(response) {

                                    let $popupTitle = $('#get-virtual-card-result').find('.popup-inline__title').find('.result');
                                    let $popupContent = $('#get-virtual-card-result').find('.popup-inline__content').find('.popup-inline__success');

                                    $popupTitle.html('');
                                    $popupContent.html('');

                                    let isError = true;

                                    if (response.status === 'ok') {
                                        if (response.cards_found) {

                                            let cardList = [];

                                            for (let i in response.barcodes) {
                                                cardList[i] = `<b style="font-size: 26px;">` + response.cards_found[i] + `</b><br>` + response.barcodes[i];
                                            }

                                            let msg = window.getVirtulCardMsg.found_card[1].replace('#CARD_LIST#', cardList.join('<br><br>'));

                                            $popupTitle.html(window.getVirtulCardMsg.found_card[0]);
                                            $popupContent.html(msg);
                                            /*
                                            $popupContent.html(
                                              `
                                                              <br>
                                                              На эти контактные данные уже оформлена виртуальная карта.
                                                              <br>
                                                              <br>
                                                              ` + cardList.join('<br><br>') + `
                                                              <br>
                                                              <br>
                                                              Также номер отправлен на E-Mail.
                                                              `
                                            );*/

                                            isError = false;
                                        } else if (response.card_number) {

                                            let msg = window.getVirtulCardMsg.create_card[1].replace('#CARD_NUMBER#', response.card_number);
                                            msg = msg.replace('#BAR_CODE#', response.barcode);

                                            $popupTitle.html(window.getVirtulCardMsg.create_card[0]);
                                            $popupContent.html(msg);
                                            /*
                                            $popupContent.html(
                                              `
                                                              <br>
                                                              Спасибо за регистрацию в программе лояльности New Balance!
                                                              <br>
                                                              <br>
                                                              Номер вашей карты:
                                                              <br>
                                                              <br>
                                                              <b style="font-size: 26px;">` + response.card_number + `</b>
                                                              <br>
                                                              ` + response.barcode + `
                                                              <br>
                                                              <br>
                                                              Также номер отправлен на E-Mail.
                                                              `
                                            );*/

                                            isError = false;
                                        }
                                    }

                                    if (isError) {

                                        $popupTitle.html(window.getVirtulCardMsg.error[0]);
                                        $popupContent.html(window.getVirtulCardMsg.error[1]);
                                        /*
                                        $popupContent.html(
                                          `
                                                        <br>
                                                        При создании карты произошла ошибка.
                                                        <br>
                                                        Попробуйте ещё раз позже.
                                                        `
                                        );*/

                                    }

                                    $.magnificPopup.close();
                                    setTimeout(() => {
                                        $.magnificPopup.open({
                                            items: {
                                                src: '#get-virtual-card-result'
                                            },
                                            type: 'inline',
                                            midClick: true,
                                            closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                                            removalDelay: 500, //delay removal by X to allow out-animation
                                            callbacks: {
                                                beforeOpen: function() {
                                                    this.st.mainClass = 'mfp-right-left';
                                                }
                                            }
                                        });
                                    }, 500);

                                    if ($('[data-preloader]').length > 0) {
                                        $('[data-preloader]').hide();
                                    }

                                },
                                'json'
                            );

                        } else if ($(form).find('[data-auth-submit]').length > 0) {
                            event.preventDefault();

                            let passwordElement = $(form).find('input[name="password"]');
                            $(form).find(".js-auth-invalid").remove();
                            passwordElement.removeClass("invalid");

                            let email = $(form).find('input[type=email]').val();
                            let password = passwordElement.val();
                            let remember = $(form).find('input[name="remember-me"]').is(":checked") === true ? "Y" : "N";
                            let favNoAuth = window.favorites_no_auth;

                            xhr = $.post(
                                '/local/ajax/auth.php',
                                {
                                    action: $(form).data('action'),
                                    email: email,
                                    password: password,
                                    remember: remember,
                                    fav: favNoAuth,
                                },
                                function(_response) {
                                    if (_response['RESULT'] === 'OK') {

                                        // событие авторизации
                                        // ga('send','event','Auth','Logged In');
                                        // ym(26442009,'reachGoal','LoggedIn');

                                        window.location.reload();
                                    } else {
                                        let passwordName = passwordElement.attr("name");
                                        let label = $("<label></label>").attr("for", passwordName).addClass("invalid js-auth-invalid").text(_response["MESSAGE"]);
                                        passwordElement.addClass("invalid").after(label);

                                        if ($('[data-preloader]').length > 0) {
                                            $('[data-preloader]').hide();
                                        }
                                    }
                                },
                                'json'
                            );
                        } else if ($(form).find('[data-registration-code-sumbit]').length > 0) {
                            event.preventDefault();

                            if (!window.registrationForm) {
                                window.registrationForm = $(form);
                            }

                            $(form).find('input').removeClass('invalid');
                            $(form).find('.js-auth-invalid').remove();

                            let errorNode = $(form).siblings('.error');

                            errorNode.text('');

                            let mailing = 'N';

                            if ($(form).find('input[name=mailing]').is(':checked')) {
                                mailing = 'Y'
                            }

                            let fields = {
                                sessid: $(form).find('input[name=sessid]'),
                                name: $(form).find('input[name=name]'),
                                last_name: $(form).find('input[name=surname]'),
                                second_name: $(form).find('input[name=patronymic]'),
                                phone: $(form).find('input[name=tel]'),
                                email: $(form).find('input[name=email]'),
                                sex: $(form).find('input[name=gender]'),
                                birthDay: `${$(form).find('select[name=day]').val()}.${$(form).find('select[name=month]').val()}.${$(form).find('select[name=year]').val()}`,
                                password: $(form).find('input[name=password]'),
                                confirmPassword: $(form).find('input[name=repeatPassword]'),
                                captcha_token_v2: $(form).find('input[name=captcha_token_v2]'),
                                captcha_token_v3: $(form).find('input[name=captcha_token_v3]'),
                            }

                            let data = {
                                sessid: fields.sessid.val(),
                                action: $(form).data('action'),
                                email: fields.email.val(),
                                name: fields.name.val(),
                                last_name: fields.last_name.val(),
                                second_name: fields.second_name.val(),
                                phone: fields.phone.val(),
                                birthDay: fields.birthDay,
                                sex: fields.sex.val(),
                                password: fields.password.val(),
                                confirmPassword: fields.confirmPassword.val(),
                                submitMailing: mailing,
                                checkAuth: true,
                                captcha_token_v2: fields.captcha_token_v2.val(),
                                captcha_token_v3: fields.captcha_token_v3.val(),
                            }

                            let label = $('<label></label>');
                            let error = '';

                            /*
                            // Retail Rocket
                            if (mailing === 'Y') {
                                let _form = $(form);
                                let mailingData = {};
                                let date = new Date();
                                let gender = 'Male';
                                let age = 0;

                                if (fields.sex === 'F') {
                                    gender = 'Female';
                                }

                                mailingData['gender'] = gender;

                                if (typeof window.stock_id != 'undefined') {
                                    mailingData['stockId'] = window.stock_id;
                                }

                                if (
                                    (typeof fields.name != 'undefined')
                                    && (fields.name.length > 0)
                                ) {
                                    mailingData['name'] = fields.name;
                                }

                                if (
                                    (typeof fields.birthDay != 'undefined')
                                    && (fields.birthDay.length > 0)
                                ) {
                                    mailingData['birthday'] = fields.birthDay;
                                }

                                try {
                                    age = date.getFullYear() - parseInt(_form.find('select[name=year]').val());

                                    if (age <= 0) {
                                        age = 0;
                                    }
                                } catch (e) {}

                                if (age > 0) {
                                    mailingData['age'] = age;
                                }

                                (window['rrApiOnReady'] = window['rrApiOnReady'] || [])
                                    .push(function() {
                                        rrApi.setEmail(data.email, mailingData);
                                    });
                            }
                            */

                            /*
                            if (!window.checkData) {
                                xhr = $.post(
                                    '/local/ajax/authcard.php',
                                    data,
                                    function(_response) {
                                        if (_response['RESULT'] === 'OK') {
                                            $('#popup-registration-confirm').find('.check-email').html(fields.email.val());

                                            $(form).find('[data-hidden-confirm]').trigger('click');
                                        } else if (_response['REASON'] === 'EXISTS') {
                                            error = 'Такой email уже существует';
                                        } else if (_response['MESSAGE'] === 'spam') {
                                            error = 'Зарегистрирована попытка нечестной регистрации';
                                        } else {
                                            error = 'Возникли проблемы при обработке запроса. Повторите, пожалуйста, попытку позже.';
                                        }

                                        if (error.length > 0) {
                                            let key = _response['FIELD'].toLowerCase();

                                            label.attr('for', fields[key].attr('name')).addClass('invalid js-auth-invalid').text(error);
                                            fields[key].addClass('invalid').after(label);

                                            let formError = fields[key].closest('form');
                                            let elFirst = formError.find('input.invalid').eq(0);

                                            $('html, body').animate(
                                                {
                                                    scrollTop: elFirst.offset().top - $('[data-header-sticky]').innerHeight() - 30 + 'px',
                                                },
                                                500
                                            );
                                        }

                                        if ($('[data-preloader]').length > 0) {
                                            $('[data-preloader]').hide();
                                        }
                                    },
                                    'json'
                                );
                            } else {
                            */

                                if (
                                    (typeof grecaptcha != 'undefined')
                                    && (typeof window.captcha_key_site_v3 != 'undefined')
                                ) {
                                    grecaptcha.ready(function () {
                                        grecaptcha.execute(window.captcha_key_site_v3, {action: 'submit'}).then(function (token) {
                                            if (token) {
                                                $(form).find('input[name="captcha_token_v3"]').val(token);

                                                data.captcha_token_v3 = fields.captcha_token_v3.val();

                                                $.post(
                                                    '/local/ajax/registration.php',
                                                    data,
                                                    function(_response) {
                                                        if (_response['RESULT'] === 'OK') {
                                                            window.location.href = '/personal/profile/';
                                                        } else {
                                                            if ($('[data-preloader]').length > 0) {
                                                                $('[data-preloader]').hide();
                                                            }

                                                            // Если ошибки есть, то будем запрашивать код еще раз
                                                            window.checkData = false;

                                                            if (window.widgetCaptcha !== false) {
                                                                grecaptcha.reset(window.widgetCaptcha)
                                                            }

                                                            // если ошибка была в версии v3, показываем видимую капчу v2
                                                            // widgetCaptcha - идентификатор, т.е. можно рендерить и управлять несколькими штуками
                                                            if (
                                                                (_response['MESSAGE'] === 'fall_captcha_v3')
                                                                && !window.widgetCaptcha
                                                            ) {
                                                                window.widgetCaptcha = grecaptcha.render(
                                                                    'captcha',
                                                                    {
                                                                        'sitekey': window.captcha_key_site_v2,
                                                                        'theme': 'light',
                                                                        'callback': function (token) {
                                                                            $(form).find('input[name="captcha_token_v2"]').val(token);
                                                                            $(form).find('[data-registration-code-sumbit]').trigger('click');
                                                                        },
                                                                    }
                                                                );
                                                            } else {
                                                                errorNode.text(_response['MESSAGE']);

                                                                let parent = (($(form).closest('#popup-auth').length > 0) ? '#popup-auth' : 'html, body');

                                                                $(parent).animate(
                                                                    {
                                                                        scrollTop: errorNode.offset().top - $('[data-header-sticky]').innerHeight() - 30 + 'px',
                                                                    },
                                                                    500
                                                                );
                                                            }
                                                        }
                                                    },
                                                    'json'
                                                );
                                            }
                                        })
                                    })
                                }

                            /*
                            }
                            */

                        } else if ($(form).find('[data-confirm-regcode]').length > 0) {
                            event.preventDefault();
                            let sessid = $(form).find('input[name=sessid]').val();
                            let emailCodeElement = $(form).find('input[name=email]');
                            let emailCode = $(form).find('input[name=email]').val();


                            let emailName = emailCodeElement.attr("name");
                            let labelElementEmail = $("<label></label>").attr("for", emailName).addClass("invalid js-auth-invalid");
                            let data = {
                                sessid: sessid,
                                action: "checkregcode",
                                email: emailCode,
                            }

                            xhr = $.post(
                                '/local/ajax/authcard.php',
                                data,
                                function(_response) {
                                    let _error = false;

                                    if (!_response.CHECK.email) {
                                        _error = true;
                                        let label = labelElementEmail.text('Код подтверждения неверный');
                                        emailCodeElement.addClass("invalid").after(label);
                                    }

                                    if (!_error) {

                                        // событие регистрации
                                        // ga('send','event','Auth','Registered');
                                        // ym(26442009,'reachGoal','Registration')

                                        window.checkData = true;
                                        $.magnificPopup.close();
                                        window.registrationForm.find('[type="submit"]').click();
                                    }

                                    if (_error) {
                                        if ($('[data-preloader]').length > 0) {
                                            $('[data-preloader]').hide();
                                        }
                                    }
                                },
                                'json'
                            );
                        } else if ($(form).find('[data-bonus-card-auth]').length > 0) {
                            let cardNumberElement = $(form).find('input[name="popup-card-num"]');
                            let pinNumberElement = $(form).find('input[name="popup-pin"]');
                            let sessid = $(form).find('input[name=sessid]').val();
                            $(form).find(".js-auth-invalid").remove();
                            cardNumberElement.removeClass("invalid");

                            window.cardNumber = $.trim(cardNumberElement.val());
                            let card = window.cardNumber;
                            let pin = $(form).find('input[name="popup-pin"]').val();
                            let data = {
                                sessid: sessid,
                                action: 'card',
                                cardNumber: card,
                                pinCode: pin,
                            }

                            let cardName = cardNumberElement.attr("name");
                            let pinName = cardNumberElement.attr("name");
                            let labelElement = $("<label></label>").attr("for", cardName).addClass("invalid js-auth-invalid");
                            let labelElementPin = $("<label></label>").attr("for", pinName).addClass("invalid js-auth-invalid");
                            xhr = $.post(
                                '/local/ajax/authcard.php',
                                data,
                                function(_response) {
                                    let hidePreloader = false;
                                    if (_response['RESULT'] === 'OK') {

                                        // событие авторизации
                                        // ga('send','event','Auth','Logged In');
                                        // ym(26442009,'reachGoal','LoggedIn');

                                        window.location.href = "/personal/profile/";
                                    } else if (_response['FIELD'] === 'CONTACT') {
                                        $(form).closest("#popup-bonus-card-auth").find('.auth-blocks').addClass('hidden');
                                        $(form).closest("#popup-bonus-card-auth").find('.third-block').removeClass('hidden');
                                        hidePreloader = true;
                                    } else if (_response['FIELD'] === 'NOT_EMAIL') {
                                        $(form).closest("#popup-bonus-card-auth").find('.auth-blocks').addClass('hidden');
                                        $(form).closest("#popup-bonus-card-auth").find('.second-block').removeClass('hidden');
                                        hidePreloader = true;
                                    } else if (_response['FIELD'] === 'PINCODE') {
                                        let label = labelElementPin.text('Пин-код неверен');
                                        pinNumberElement.addClass("invalid").after(label);
                                        hidePreloader = true;
                                    } else if (_response['FIELD'] === 'NEW_CARD') {
                                        let label = labelElement.html("К сожалению, ваша карта не активирована. Обратитесь в службу поддержки для активации карты по телефону <a href=\"tel:88007707597\">8 800 770 75 97</a>");
                                        cardNumberElement.addClass("invalid").after(label);
                                        hidePreloader = true;
                                    } else {
                                        let label = labelElement.text('Карта не найдена');
                                        cardNumberElement.addClass("invalid").after(label);
                                        hidePreloader = true;
                                    }

                                    if (hidePreloader == true) {
                                        if ($('[data-preloader]').length > 0) {
                                            $('[data-preloader]').hide();
                                        }
                                    }
                                },
                                'json'
                            );
                        } else if ($(form).find('[data-bonus-get-card]').length > 0) {
                            if (!window.cardNumber) return false;

                            let sessid = $(form).find('input[name=sessid]').val();
                            let email = $(form).find('input[name=email]').val();
                            let name = $(form).find('input[name=name]').val();
                            let lastName = $(form).find('input[name=surname]').val();
                            let secondName = $(form).find('input[name=patronymic]').val();
                            let sex = $(form).find('input[name=gender]').val();
                            let birthDay = `${$(form).find('select[name=day]').val()}.${$(form).find('select[name=month]').val()}.${$(form).find('select[name=year]').val()}`;
                            let phone = $(form).find('input[name=tel]').val();
                            let agree = $(form).find('input[name="reg-check"]').val();
                            let data = {
                                sessid: sessid,
                                action: 'contact',
                                cardContactName: name,
                                cardContactLastName: lastName,
                                cardContactSecondName: secondName,
                                cardContactSex: sex,
                                cardContactBirthday: birthDay,
                                cardContactPhone: phone,
                                cardContactEmail: email,
                                cardContactAgree: agree,
                                cardNumber: window.cardNumber
                            }

                            xhr = $.post(
                                '/local/ajax/authcard.php',
                                data,
                                function(_response) {
                                    if (_response['RESULT'] === 'SEND') {
                                        // высланы коды подтверждения
                                        $(form).closest("#popup-bonus-card-auth").find('.auth-blocks').addClass('hidden');
                                        $(form).closest("#popup-bonus-card-auth").find('.fours-block').removeClass('hidden');

                                        $(form).closest("#popup-bonus-card-auth").find('.fours-block').find('.check-phone').text(phone);
                                        $(form).closest("#popup-bonus-card-auth").find('.fours-block').find('.check-email').text(email);
                                    }

                                    if ($('[data-preloader]').length > 0) {
                                        $('[data-preloader]').hide();
                                    }
                                },
                                'json'
                            );
                        } else if ($(form).find('[data-bonus-edit-contact]').length > 0) {
                            if (!window.cardNumber) return false;

                            let birthDay = `${$(form).find('select[name=day]').val()}.${$(form).find('select[name=month]').val()}.${$(form).find('select[name=year]').val()}`;
                            let formSerialize = $(form).serialize()
                            let data = formSerialize + "&birthday=" + birthDay
                            let errorBlock = $(form).find(['data-error-bonus-edit']);

                            $.post('/local/ajax/bonuscard.php', data, function(_e) {
                                if (_e['RESULT'] == 'OK') {
                                    $.magnificPopup.close();
                                    setTimeout(() => {
                                        $.magnificPopup.open({
                                            items: {
                                                src: '#data-popup-profile-edit-success'
                                            },
                                            type: 'inline',
                                            closeOnBgClick: true,
                                            midClick: true,
                                            closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                                            removalDelay: 500, //delay removal by X to allow out-animation
                                            callbacks: {
                                                beforeOpen: function() {
                                                    this.st.mainClass = 'mfp-zoom-in mfp-modal';
                                                }
                                            }
                                        });
                                    }, 500);
                                    errorBlock.text('')
                                    errorBlock.addClass('d-none')
                                } else {
                                    errorBlock.text(_e['MESSAGE'])
                                    errorBlock.removeClass('d-none')
                                }

                                if ($('[data-preloader]').length > 0) {
                                    $('[data-preloader]').hide();
                                }
                            }, 'json');
                        } else if ($(form).find('[data-bonus-confirm-code]').length > 0) {
                            if (!window.cardNumber) return false;
                            let phoneElement = $(form).find('input[name=phone]');
                            let emailElement = $(form).find('input[name=email]');
                            $(form).find(".js-auth-invalid").remove();
                            phoneElement.removeClass("invalid");
                            emailElement.removeClass("invalid");

                            let sessid = $(form).find('input[name=sessid]').val();
                            let phone = phoneElement.val();
                            let email = emailElement.val();

                            let data = {
                                sessid: sessid,
                                action: 'confirm',
                                cardConfirmPhone: phone,
                                cardConfirmEmail: email,
                                cardNumber: window.cardNumber
                            }

                            xhr = $.post(
                                '/local/ajax/authcard.php',
                                data,
                                function(_response) {
                                    if (_response['RESULT'] === 'ERROR') {
                                        if ($.inArray('phone', _response['ERROR']) != -1) {
                                            let phoneName = phoneElement.attr("name");
                                            let label = $("<label></label>").attr("for", phoneName).addClass("invalid js-auth-invalid").text('Неверный код подтверждения');
                                            phoneElement.addClass("invalid").after(label);
                                        }
                                        if ($.inArray('email', _response['ERROR']) != -1) {
                                            let emailName = emailElement.attr("name");
                                            let label = $("<label></label>").attr("for", emailName).addClass("invalid js-auth-invalid").text('Неверный код подтверждения');
                                            emailElement.addClass("invalid").after(label);
                                        }
                                    } else {
                                        // найден контакт, запустим процесс отправки формы ввода пин-кода заново
                                        $(form).closest("#popup-bonus-card-auth").find('.auth-blocks').addClass('hidden');
                                        $(form).closest("#popup-bonus-card-auth").find('.first-block').removeClass('hidden');
                                        $(form).closest("#popup-bonus-card-auth").find('.first-block form').submit();
                                    }

                                    if ($('[data-preloader]').length > 0) {
                                        $('[data-preloader]').hide();
                                    }
                                },
                                'json'
                            );
                        } else if ($(form).find('[data-bonus-card-email]').length > 0) {
                            if (!window.cardNumber) return false;
                            let passwordElement = $(form).find('input[name="password"]');
                            $(form).find(".js-auth-invalid").remove();
                            passwordElement.removeClass("invalid");

                            let sessid = $(form).find('input[name=sessid]').val();
                            let email = $(form).find('input[name=email]').val();
                            let pass = passwordElement.val();
                            let data = {
                                sessid: sessid,
                                action: 'email',
                                cardEmail: email,
                                cardEmailPass: pass,
                                cardNumber: window.cardNumber,
                            }

                            xhr = $.post(
                                '/local/ajax/authcard.php',
                                data,
                                function(_response) {
                                    if (_response['RELOAD']) {
                                        location.href = "/personal/profile/";
                                    } else {
                                        if (_response['FIELD'] === 'EXIST') {
                                            $(form).find('.js-card-pass').removeClass('hidden');
                                        } else if (_response['FIELD'] === 'PASS') {
                                            let passwordName = passwordElement.attr("name");
                                            let label = $("<label></label>").attr("for", passwordName).addClass("invalid js-auth-invalid").text('Пароль неверен');
                                            passwordElement.addClass("invalid").after(label);
                                        }

                                        if ($('[data-preloader]').length > 0) {
                                            $('[data-preloader]').hide();
                                        }
                                    }
                                },
                                'json'
                            );
                        } else if ($(form).find('[data-popup-forgot-submit]').length > 0) {
                            event.preventDefault();
                            let loginElement = $(form).find('input[type=email]');

                            $(form).find(".js-forgot-invalid").remove();
                            loginElement.removeClass("invalid");

                            let sessid = $(form).find('input[name=sessid]').val();
                            let login = loginElement.val();

                            let data = {
                                sessid: sessid,
                                login: login,
                            }

                            xhr = $.post(
                                '/local/ajax/forgot.php',
                                data,
                                function(_response) {
                                    if (_response['status'] === 'ok') {
                                        $("#popup-recovery-message").find(".js-recovery-title").text(_response['message']);
                                        $(form).find('[data-hidden-confirm]').trigger('click')
                                        loginElement.val("");
                                    } else {
                                        let emailName = loginElement.attr("name");
                                        let label = $("<label></label>").attr("for", emailName).addClass("invalid js-forgot-invalid").text(_response["message"]);
                                        loginElement.addClass("invalid").after(label);
                                    }

                                    if ($('[data-preloader]').length > 0) {
                                        $('[data-preloader]').hide();
                                    }
                                },
                                'json'
                            );
                        } else if ($(form).find('[data-email-subscribe]').length > 0) {
                            let data = $(form).serializeArray();

                            let subscribeLkForm = $('[data-subscribe-blocks]').find('[data-subscribe-block]');
                            let unSubscribeLkForm = $('[data-subscribe-blocks]').find('[data-unsubscribe-block]');
                            $.post(
                                $(form).attr("action"),
                                data,
                                function(_response) {
                                    if (_response['RESULT'] === 'Y') {
                                        unSubscribeLkForm.removeClass('d-none')
                                        subscribeLkForm.addClass('d-none')
                                        $(form).find(".js-unsubscribe-text").html(_response["MESSAGE"])
                                    } else {
                                        unSubscribeLkForm.addClass('d-none')
                                        subscribeLkForm.removeClass('d-none')
                                        $(form).find(".js-subscribe-text").html(_response["MESSAGE"])
                                    }

                                    if ($('[data-preloader]').length > 0) {
                                        $('[data-preloader]').hide();
                                    }
                                },
                                'json'
                            );
                        } else if ($(form).find('[data-review-form]').length > 0) {
                            let action = $(form).attr('action');
                            let rating = $(form).find('[data-rating]').attr('data-rating');
                            $(form).find('input[name=RATING]').val(rating);
                            let payload = new FormData($(form)[0]);
                            payload.delete('PHOTO');
                            window.files['PHOTO'].forEach(function(file) {
                                payload.append('PHOTO[]', file, file.name);
                            });
                            if (window.xhr_data_review_form && window.xhr_data_review_form.readyState != 4) {
                                window.xhr_data_review_form.abort();
                            }

                            window.xhr_data_review_form = $.ajax({
                                type: 'POST',
                                url: action,
                                data: payload,
                                processData: false,
                                contentType: false,
                                dataType: 'json'
                            }).done(function(data) {
                                let thisProductId = $('input[data-product]:checked').val();
                                if (data['STATUS'] === 'OK') {
                                    $('[data-product]').each(function() {
                                        let _this = $(this);
                                        if (_this.val() === thisProductId) {
                                            _this.attr('disabled', 'disabled')
                                            _this.closest('div').find('[data-text-rewiew]').append('<p class="color-monza">Отзыв отправлен</p>')
                                        }
                                    })
                                }
                                $('#popup-add-review-result').find('.result-content').html(data['HTML']);

                                $.magnificPopup.close();

                                setTimeout(() => {
                                    $.magnificPopup.open({
                                        items: {
                                            src: '#popup-add-review-result'
                                        },
                                        type: 'inline',
                                        midClick: true,
                                        closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                                        removalDelay: 500, //delay removal by X to allow out-animation
                                        callbacks: {
                                            beforeOpen: function() {
                                                this.st.mainClass = 'mfp-zoom-in';
                                            }
                                        }
                                    });
                                }, 500);

                                $(form)[0].reset();
                                $('[data-file-remove]').trigger('click')
                                if ($('input[data-product]:not(:disabled)').length == 0) {
                                    $('.form-container').remove();
                                }

                                if ($('[data-preloader]').length > 0) {
                                    $('[data-preloader]').hide();
                                }
                            })
                        } else if ($(form).find('[data-bonus-create-new]').length > 0) {

                            event.preventDefault();
                            if (window.xhr_new_bonus_card && window.xhr_new_bonus_card.readyState != 4) {
                                window.xhr_new_bonus_card.abort();
                            }
                            let fields = {
                                sessid: $(form).find('input[name=sessid]'),
                                name: $(form).find('input[name=name]'),
                                last_name: $(form).find('input[name=last_name]'),
                                second_name: $(form).find('input[name=second_name]'),
                                phone: $(form).find('input[name=phone]'),
                                email: $(form).find('input[name=email]'),
                                sex: $(form).find('input[name=sex]'),
                                action: $(form).find('input[name=action]'),
                                birthday: `${$(form).find('select[name=day]').val()}.${$(form).find('select[name=month]').val()}.${$(form).find('select[name=year]').val()}`,
                            }
                            let data = {
                                sessid: fields.sessid.val(),
                                action: fields.action.val(),
                                email: fields.email.val(),
                                name: fields.name.val(),
                                last_name: fields.last_name.val(),
                                second_name: fields.second_name.val(),
                                phone: fields.phone.val(),
                                birthday: fields.birthday,
                                sex: fields.sex.val(),
                                checkAuth: true,
                            }
                            window.xhr_new_bonus_card = $.post('/local/ajax/bonuscard.php',
                                data,
                                function(_e) {

                                    if (_e['RESULT'] == 'find') {

                                        // нашли карту по телефону \ емейлу
                                        var _firstCard = _e['CARD'][0];
                                        $('[data-bonus-card-number]').val(_firstCard);
                                        var _mess = 'По введенным контактным данным мы нашли Вашу карту: №' + _firstCard + '<br>' + '<a class="link" href="#" data-link-add-card>Привяжите ее к своему аккаунту</a>'
                                        if (_e['CARD'].length > 1) {
                                            _mess += '<br /><br />Найдено несколько карт: ' + _e['CARD'].join(', ') + '. Чтобы объединить карты и бонусы на них, ' + window.helpText;
                                        }

                                        $('[data-success-bonus-card-edit-title]').text('У Вас уже есть карта!');
                                        $('[data-success-bonus-card-edit-text]').html(_mess);
                                        $.magnificPopup.close();
                                        setTimeout(() => {
                                            $.magnificPopup.open({
                                                items: {
                                                    src: '#data-popup-profile-create-bonus-card-success'
                                                },
                                                type: 'inline',
                                                closeOnBgClick: true,
                                                midClick: true,
                                                closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                                                removalDelay: 500, //delay removal by X to allow out-animation
                                                callbacks: {
                                                    beforeOpen: function() {
                                                        this.st.mainClass = 'mfp-zoom-in mfp-modal';
                                                    }
                                                }
                                            });
                                        }, 500);
                                        $('[data-link-add-card]').click(function(ev) {
                                            ev.preventDefault();
                                            $.magnificPopup.close();
                                            setTimeout(() => {
                                                $('[data-link-add-bonus-card]').trigger('click')
                                            }, 500);
                                        })
                                    } else {
                                        //закрываем эту форму переводим на форму ввода кода из смс и эмейл
                                        $('[data-confirm-reg-new-bonus]').trigger('click')
                                    }

                                    if ($('[data-preloader]').length > 0) {
                                        $('[data-preloader]').hide();
                                    }
                                }, 'json');
                        } else if ($(form).find('[data-confirm-regcode-bonus-card]').length > 0) {

                            if (window.xhr_confirm_regcode_bonus_card && window.xhr_confirm_regcode_bonus_card.readyState != 4) {
                                window.xhr_confirm_regcode_bonus_card.abort();
                            }
                            event.preventDefault();
                            let phoneCodeElement = $(form).find('input[name=phone]');
                            let emailCodeElement = $(form).find('input[name=email]');
                            let phoneCode = $(form).find('input[name=phone]').val();
                            let emailCode = $(form).find('input[name=email]').val();


                            let phoneName = phoneCodeElement.attr("name");
                            let emailName = emailCodeElement.attr("name");
                            let labelElementPhone = $("<label></label>").attr("for", phoneName).addClass("invalid js-auth-invalid");
                            let labelElementEmail = $("<label></label>").attr("for", emailName).addClass("invalid js-auth-invalid");

                            window.xhr_confirm_regcode_bonus_card = $.post('/local/ajax/bonuscard.php', {
                                action: 'newCardCheck',
                                phone: phoneCode,
                                email: emailCode
                            }, function(_e) {
                                if (_e['RESULT'] == 'OK') {
                                    // все верно, карта создана и привязана
                                    $('[data-success-bonus-card-edit-title]').html('Ваша карта - <b>№' + _e['CARD'] + '</b>.');
                                    $('[data-success-bonus-card-edit-text]').text('Страница перезагрузится через 3 секунды.');
                                    $.magnificPopup.close();
                                    setTimeout(() => {
                                        $.magnificPopup.open({
                                            items: {
                                                src: '#data-popup-profile-create-bonus-card-success'
                                            },
                                            type: 'inline',
                                            closeOnBgClick: true,
                                            midClick: true,
                                            closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                                            removalDelay: 500, //delay removal by X to allow out-animation
                                            callbacks: {
                                                beforeOpen: function() {
                                                    this.st.mainClass = 'mfp-zoom-in mfp-modal';
                                                }
                                            }
                                        });
                                    }, 500);
                                    setTimeout(window.location.reload(), 3500);
                                } else {
                                    if ($.inArray('phone', _e['ERROR']) != -1) {
                                        let label = labelElementPhone.text('Код подтверждения неверный');
                                        phoneCodeElement.addClass("invalid").after(label);

                                    }
                                    if ($.inArray('email', _e['ERROR']) != -1) {
                                        let label = labelElementEmail.text('Код подтверждения неверный');
                                        emailCodeElement.addClass("invalid").after(label);
                                    }
                                }

                                if ($('[data-preloader]').length > 0) {
                                    $('[data-preloader]').hide();
                                }
                            }, 'json');
                        }
                    } else {
                        if ($('[data-preloader]').length > 0) {
                            $('[data-preloader]').show();
                        }
                        if ($(form).find('[data-subscribe-ok]').length > 0) {
                            let subscribeSuccess = $('#popup-subscribe-success');
                            let email = $(form).find('input[type=email]').val();
                            let action = $(form).attr('action'),
                                dataForm = $(form).serializeArray();

                            let subscribeLkForm = $('[data-subscribe-blocks]').find('[data-subscribe-block]');
                            let unSubscribeLkForm = $('[data-subscribe-blocks]').find('[data-unsubscribe-block]');

                            if (window.xhr_subscribe && window.xhr_subscribe.readyState != 4) {
                                window.xhr_subscribe.abort();
                            }
                            window.xhr_subscribe = $.ajax({
                                type: "POST",
                                url: action,
                                data: dataForm,
                                dataType: "json",
                                success: function(msg) {
                                    $.cookie('subscribe', 'Y', {expires: 730, path: '/'});
                                    if (msg['RESULT'] === 'Y') {
                                        // Если подписывваемся в ЛК --start
                                        if (window.location.pathname === '/personal/profile/') {
                                            unSubscribeLkForm.removeClass('d-none')
                                            subscribeLkForm.addClass('d-none')
                                        }
                                        // Если подписывваемся в ЛК --end
                                        subscribeSuccess.find('.result').text(msg['MESSAGE']);
                                        subscribeSuccess.find('input[type=email]').val(email);
                                        $(form).find(".js-subscribe-text").html(msg["MESSAGE"])
                                    } else {
                                        // Если подписывваемся в ЛК --start
                                        if (window.location.pathname === '/personal/profile/') {
                                            unSubscribeLkForm.addClass('d-none')
                                            subscribeLkForm.removeClass('d-none')
                                        }
                                        // Если подписывваемся в ЛК --end
                                        $(form).find(".js-unsubscribe-text").html(msg["MESSAGE"])
                                        subscribeSuccess.find('input[type=email]').val(email);
                                    }

                                    $.magnificPopup.close();
                                    setTimeout(() => {
                                        $.magnificPopup.open({
                                            items: {
                                                src: '#popup-subscribe-success'
                                            },
                                            type: 'inline',
                                            midClick: true,
                                            closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                                            removalDelay: 500, //delay removal by X to allow out-animation
                                            callbacks: {
                                                beforeOpen: function() {
                                                    this.st.mainClass = 'mfp-right-left';
                                                }
                                            }
                                        });
                                    }, 500);

                                    if ($('[data-preloader]').length > 0) {
                                        $('[data-preloader]').hide();
                                    }
                                },
                                error: function(xhr, ajaxOptions, thrownError) {
                                    // console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                                }
                            });
                        } else if ($(form).find('[data-bonus-submit]').length > 0) {
                            event.preventDefault();
                            let tel = $(form).find('[data-bonus-tel]');

                            if (process.env.NODE_ENV === 'development') {
                                let content = `
                  <p>Мы выслали Вам код подтверждения, укажите его в специальном текстовом поле.</p>
                  <p>Код был отправлен на телефон: ${tel.val()}</p>
                `;

                                $(form).prepend(content);
                                $(form).find('.popup-inline__text').addClass('d-none');
                                $(form).find('[data-bonus-card]').closest('.col-12').addClass('d-none');
                                $(form).find('[data-bonus-tel]').closest('.col-12').addClass('d-none');
                                $(form).find('[data-bonus-submit]').parent().remove();

                                $(form).find('[data-bonus-code]').closest('.col-12').removeClass('d-none');
                                $(form).find('[data-bonus-button]').parent().removeClass('d-none');

                                setTimeout(() => {
                                    $(form).children('p').remove();
                                    $(form).find('.popup-inline__text').removeClass('d-none');
                                    $(form).find('[data-bonus-card]').val('').closest('.col-12').removeClass('d-none');
                                    $(form).find('[data-bonus-tel]').val('').closest('.col-12').removeClass('d-none');
                                    $(form).find('[data-bonus-submit]').parent().removeClass('d-none');

                                    $(form).find('[data-bonus-code]').val('').closest('.col-12').addClass('d-none');
                                    $(form).find('[data-bonus-button]').parent().addClass('d-none');

                                    $(form).find('[data-bonus-button]').parent().parent().append('<div class="popup-inline__btn-item"><button class="btn--full btn--border btn" type="submit" data-bonus-submit="">Проверить баланс</button></div>')
                                }, 120000);
                            }

                            let card = $(form).find('[data-bonus-card]');
                            let cardError = $(form).find('#card-error');
                            let telError = $(form).find('#phone-error');

                            if (window.xhr_bonus_submit && window.xhr_bonus_submit.readyState != 4) {
                                window.xhr_bonus_submit.abort();
                            }
                            window.xhr_bonus_submit = $.post('/local/ajax/bonuscard.php', {
                                action: 'checkBalance',
                                card: card.val(),
                                phone: tel.val(),
                            }, function(e) {
                                if (e.RESULT == 'ERROR') {
                                    if (e.ERROR == 'CARD') {
                                        card.addClass('invalid')
                                        card.attr('aria-invalid', 'true');
                                        if (cardError.length > 0) {
                                            cardError.show();
                                            cardError.text('Карта не найдена');
                                        } else {
                                            let label = $("<label></label>").attr("for", "card").attr('id', 'card-error').addClass("invalid").text('Карта не найдена');
                                            card.after(label);
                                        }
                                    }
                                } else {
                                    if (!e.DATA.CARD) {
                                        card.addClass('invalid')
                                        card.attr('aria-invalid', 'true')
                                        if (cardError.length > 0) {
                                            cardError.show();
                                            cardError.text('Карта не найдена');
                                        } else {
                                            let label = $("<label></label>").attr("for", "card").attr('id', 'card-error').addClass("invalid").text('Карта не найдена');
                                            card.after(label);
                                        }
                                    } else if (!e.DATA.PHONE) {
                                        tel.addClass('invalid')
                                        tel.attr('aria-invalid', 'true')
                                        if (telError.length > 0) {
                                            telError.show();
                                            telError.text('Карта не найдена');
                                        } else {
                                            let label = $("<label></label>").attr("for", "phone").attr('id', 'phone-error').addClass("invalid").text('Карта не найдена');
                                            tel.after(label);
                                        }
                                    } else {
                                        let content = `
                      <p>Мы выслали Вам код подтверждения, укажите его в специальном текстовом поле.</p>
                      <p>Код был отправлен на телефон: ${tel.val()}</p>
                    `;

                                        $(form).prepend(content);
                                        $(form).find('.popup-inline__text').addClass('d-none');
                                        $(form).find('[data-bonus-card]').closest('.col-12').addClass('d-none');
                                        $(form).find('[data-bonus-tel]').closest('.col-12').addClass('d-none');
                                        $(form).find('[data-bonus-submit]').parent().remove();

                                        $(form).find('[data-bonus-code]').closest('.col-12').removeClass('d-none');
                                        $(form).find('[data-bonus-button]').parent().removeClass('d-none');

                                        if ($('[data-preloader]').length > 0) {
                                            $('[data-preloader]').hide();
                                        }
                                        setTimeout(() => {
                                            $(form).children('p').remove();
                                            $(form).find('.popup-inline__text').removeClass('d-none');
                                            $(form).find('[data-bonus-card]').val('').closest('.col-12').removeClass('d-none');
                                            $(form).find('[data-bonus-tel]').val('').closest('.col-12').removeClass('d-none');
                                            $(form).find('[data-bonus-submit]').parent().removeClass('d-none');

                                            $(form).find('[data-bonus-code]').val('').closest('.col-12').addClass('d-none');
                                            $(form).find('[data-bonus-button]').parent().addClass('d-none');

                                            $(form).find('[data-bonus-button]').parent().parent().append('<div class="popup-inline__btn-item"><button class="btn--full btn--border btn" type="submit" data-bonus-submit="">Проверить баланс</button></div>')
                                        }, 120000);
                                    }
                                }

                            }, 'json');
                        } else if ($(form).find('[data-bonus-button]').length > 0) {
                            let code = $(form).find('[data-bonus-code]');
                            let card = $(form).find('[data-bonus-card]');
                            let codeError = $(form).find('#popup-bonus-code-error');
                            let contentBlock = $(form).closest('[data-balance-content]');

                            //if (process.env.NODE_ENV === 'development'){
                            let cardVal = card.val();
                            let content = `
                  <p>Баланс карты <b>${cardVal}</b></p>
                  <p>Активные бонусы <b>5000</b></p>
                  <p>Неподтвержденные бонусы <b>0</b></p>
                  <p>Использованные бонусы <b>0</b></p>
                `;
                            contentBlock.children().addClass('d-none')
                            contentBlock.append(content);

                            setTimeout(() => {
                                $(form).find('[data-bonus-card]').val('');
                                $(form).find('[data-bonus-tel]').val('');
                                $(form).find('[data-bonus-code]').val('');

                                contentBlock.children('p').remove();
                                contentBlock.children().removeClass('d-none')
                            }, 300000);
                            //}

                            if (window.xhr_data_bonus_button && window.xhr_data_bonus_button.readyState != 4) {
                                window.xhr_data_bonus_button.abort();
                            }
                            window.xhr_data_bonus_button = $.post('/local/ajax/bonuscard.php', {
                                action: 'checkBalanceCode',
                                code: code.val(),
                                card: card.val(),
                            }, function(e) {
                                if (e.RESULT == 'ERROR') {
                                    code.addClass('invalid')
                                    code.attr('aria-invalid', 'true')
                                    codeError.show()
                                    codeError.text('Укажите правильный код подтверждения');
                                } else {
                                    let cardVal = card.val();
                                    let activeBalance = e.DATA.ActiveBalance;
                                    let unconfirmBalance = e.DATA.UnconfirmBalance;
                                    let summ = e.DATA.Summ;
                                    let content = `
                    <p>Баланс карты <b>${cardVal}</b></p>
                    <p>Активные бонусы <b>${activeBalance}</b></p>
                    <p>Неподтвержденные бонусы <b>${unconfirmBalance}</b></p>
                    <p>Использованные бонусы <b>${summ}</b></p>
                  `;
                                    contentBlock.children().addClass('d-none')
                                    contentBlock.append(content);

                                    setTimeout(() => {
                                        $(form).find('[data-bonus-card]').val('');
                                        $(form).find('[data-bonus-tel]').val('');
                                        $(form).find('[data-bonus-code]').val('');

                                        contentBlock.children('p').remove();
                                        contentBlock.children().removeClass('d-none')
                                    }, 300000);
                                }

                                if ($('[data-preloader]').length > 0) {
                                    $('[data-preloader]').hide();
                                }
                            }, 'json');
                        } else if ($(form).find('[data-add-bonus-card]').length > 0) {
                            let pinCode = $(form).find('[name=pin-code]');
                            let card = $(form).find('[name=card]');

                            if (window.xhr_data_add_bonus_card && window.xhr_data_add_bonus_card.readyState != 4) {
                                window.xhr_data_bonus_button.abort();
                            }
                            window.xhr_data_add_bonus_card = $.post('/local/ajax/bonuscard.php', {
                                action: 'checkCard',
                                card: card.val(),
                                pinCode: pinCode.val()
                            }, function(e) {
                                if (e['RESULT'] == 'OK') {
                                    that.showCodeCard($(form), card.val(), e['CONTACT']);
                                } else {
                                    if (e['SECURE'] == true) {
                                        let label = $("<label></label>").attr("for", 'card').addClass("invalid js-valid-card").text(window.secureText);
                                        card.addClass("invalid").after(label);
                                    } else if (e['FIELD'] == 'CONTACT') {
                                        /**
                                         * Тут в старом варианте выводилась форма
                                         */
                                        $(form).find('.card-contact-no').removeClass('d-none');
                                    } else if (e['FIELD'] == 'PINCODE') {
                                        let label = $("<label></label>").attr("for", 'pin-code').addClass("invalid js-valid-pin").text('Пин-код неверен');
                                        pinCode.addClass("invalid").after(label);
                                    } else if (e['FIELD'] == 'NEW_CARD') {
                                        let label = $("<label></label>").attr("for", 'card').addClass("invalid js-valid-card").text(window.errorText['inactiveCard']);
                                        card.addClass("invalid").after(label);
                                    } else {
                                        let label = $("<label></label>").attr("for", 'card').addClass("invalid js-valid-card").text('Карта не найдена');
                                        card.addClass("invalid").after(label);
                                    }
                                }

                                if ($('[data-preloader]').length > 0) {
                                    $('[data-preloader]').hide();
                                }
                            }, 'json');

                        } else if ($(form).find('[data-add-bonus-card-virtual]').length > 0) {
                            let card = $(form).find('[name=card]');

                            if (window.xhr_data_add_bonus_card && window.xhr_data_add_bonus_card.readyState != 4) {
                                window.xhr_data_bonus_button.abort();
                            }
                            window.xhr_data_add_bonus_card = $.post('/local/ajax/bonuscard.php', {
                                action: 'checkCardVirtual',
                                card: card.val(),
                            }, function(e) {
                                if (e['RESULT'] == 'OK') {
                                    that.showCodeCard($(form), card.val(), e['CONTACT']);
                                } else {
                                    if (e['SECURE'] == true) {
                                        let label = $("<label></label>").attr("for", 'card').addClass("invalid js-valid-card").text(window.secureText);
                                        card.addClass("invalid").after(label);
                                    } else if (e['FIELD'] == 'CONTACT') {
                                        /**
                                         * Тут в старом варианте выводилась форма
                                         */
                                        $(form).find('.card-contact-no').removeClass('d-none');
                                    } else if (e['FIELD'] == 'PINCODE') {
                                        let label = $("<label></label>").attr("for", 'pin-code').addClass("invalid js-valid-pin").text('Пин-код неверен');
                                        pinCode.addClass("invalid").after(label);
                                    } else if (e['FIELD'] == 'NEW_CARD') {
                                        let label = $("<label></label>").attr("for", 'card').addClass("invalid js-valid-card").text(window.errorText['inactiveCard']);
                                        card.addClass("invalid").after(label);
                                    } else {
                                        let label = $("<label></label>").attr("for", 'card').addClass("invalid js-valid-card").text('Карта не найдена');
                                        card.addClass("invalid").after(label);
                                    }
                                }

                                if ($('[data-preloader]').length > 0) {
                                    $('[data-preloader]').hide();
                                }
                            }, 'json');
                        } else if ($(form).find('[data-addcheck-pin-bonus-card]').length > 0) {
                            let card = $(form).find('[name=card]');
                            let checkPin = $(form).find('[name=check-code]');
                            let resultMessage = $(form).find('.result-message');

                            if (window.xhr_data_addcheck_pin_bonus_card && window.xhr_data_addcheck_pin_bonus_card.readyState != 4) {
                                window.xhr_data_addcheck_pin_bonus_card.abort();
                            }
                            window.xhr_data_addcheck_pin_bonus_card = $.post('/local/ajax/bonuscard.php', {
                                action: 'confirmCard',
                                card: card.val(),
                                code: checkPin.val()
                            }, function(e) {
                                if (e['RESULT'] == 'OK') {
                                    resultMessage.html('<span class="card-success">Владение картой подтверждено.<br />Страница перезагрузится через 3 секунды.</span>');
                                    $(form).find('[data-check-pin]').addClass('d-none');
                                    $(form).find('[data-check-pin-button]').addClass('d-none');
                                    setTimeout(window.location.reload(), 3000);
                                } else {
                                    let label = $("<label></label>").attr("for", 'check-code').addClass("invalid js-valid-code").text('Неверный код подтверждения');
                                    checkPin.addClass("invalid").after(label);
                                }

                                if ($('[data-preloader]').length > 0) {
                                    $('[data-preloader]').hide();
                                }
                            }, 'json');

                        } else if ($(form).find('[data-confirm]').length > 0) {
                            let card = $(form).find('[name=card]');
                            let type = $(form).find('[name=type-message]');

                            if (window.xhr_data_confirm && window.xhr_data_confirm.readyState != 4) {
                                window.xhr_data_confirm.abort();
                            }
                            window.xhr_data_confirm = $.post('/local/ajax/bonuscard.php', {
                                action: 'codeCard',
                                card: card.val(),
                                type: type.val()
                            }, function(e) {
                                if (e['RESULT'] == 'OK') {
                                    // $(form).find('[data-send-pin]').addClass('d-none');
                                    // $(form).find('[data-send-pin-button]').addClass('d-none');
                                    $(form).find('[data-send-pin-button]').remove();
                                    $(form).find('[data-check-pin]').removeClass('d-none');
                                    $(form).find('[data-check-pin-button]').removeClass('d-none');
                                    $(form).find('[data-send-pin]').addClass('d-none');
                                    $('[data-check-pin-button-set]').append('<button class="btn--full btn--border btn" type="submit" data-addcheck-pin-bonus-card>Подтвердить</button>');
                                } else {
                                    //
                                }

                                if ($('[data-preloader]').length > 0) {
                                    $('[data-preloader]').hide();
                                }
                            }, 'json');

                        } else if ($(form).find('[data-order-ok]').length > 0) {
                            let deliveryId = parseInt($(form).find('input[name="DELIVERY_ID"]:checked').val())
                            let storeId = $('#ORDER_PROP_' + window.orderProps['F_ADDRESS']).val();

                            if (!storeId.length) {
                                let deliveryType = Object.keys(window.deliveryId).find(key => window.deliveryId[key] === deliveryId);

                                if (deliveryType === 'sdek') {
                                    $('#js-order-pickup-error').html('Не выбран пункт выдачи заказов');
                                } else if (deliveryType === 'pickup') {
                                    $('#js-order-pickup-error').html('Не выбран магазин для самовывоза товаров');
                                }

                                $.magnificPopup.open({
                                    items: {
                                        src: '#popup-order-pickup-error'
                                    },
                                    type: 'inline',
                                    midClick: true,
                                    closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                                    removalDelay: 500, //delay removal by X to allow out-animation
                                    callbacks: {
                                        beforeOpen: function() {
                                            this.st.mainClass = 'mfp-zoom-in';
                                        }
                                    }
                                });

                                $('[data-preloader]').hide();

                            } else {

                                $('#confirmorder').val('Y');
                                window.submitForm();

                            }
                        } else if ($(form).find('[data-form-success]').length > 0) {
                            $.magnificPopup.open({
                                items: {
                                    src: '#popup-message-accept'
                                },
                                type: 'inline',
                                midClick: true,
                                closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                                removalDelay: 500, //delay removal by X to allow out-animation
                                callbacks: {
                                    beforeOpen: function() {
                                        this.st.mainClass = 'mfp-zoom-in';
                                    }
                                }
                            });

                            if ($('[data-preloader]').length > 0) {
                                $('[data-preloader]').hide();
                            }
                        } else if ($(form).find('[data-delete-bonus-card]').length > 0) {
                            if (window.xhr_data_delete_bonus_card && window.xhr_data_delete_bonus_card.readyState != 4) {
                                window.xhr_data_delete_bonus_card.abort();
                            }
                            window.xhr_data_delete_bonus_card = $.post('/local/ajax/bonuscard.php', {
                                action: 'deleteCard',
                                card: window.cardNumber
                            }, 'json');
                            window.location.reload()
                            $.magnificPopup.close();

                            if ($('[data-preloader]').length > 0) {
                                $('[data-preloader]').hide();
                            }
                        } else if ($(form).find('[data-feedback-send]').length > 0) {
                            let action = $(form).attr('action');

                            var payload = new FormData($(form)[0]);

                            if ($('[data-preloader]').length > 0) {
                                $('[data-preloader]').show();
                            }
                            if (window.xhr_feedback_send && window.xhr_feedback_send.readyState != 4) {
                                window.xhr_feedback_send.abort();
                            }

                            window.xhr_feedback_send = $.ajax({
                                type: "POST",
                                url: action,
                                data: payload,
                                processData: false,
                                contentType: false,
                                success: function(msg) {
                                    let data = JSON.parse(msg)
                                    if (data['success'] === 'Y') {
                                        $.magnificPopup.open({
                                            items: {
                                                src: '#popup-message-accept'
                                            },
                                            type: 'inline',
                                            midClick: true,
                                            closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                                            removalDelay: 500, //delay removal by X to allow out-animation
                                            callbacks: {
                                                beforeOpen: function() {
                                                    this.st.mainClass = 'mfp-zoom-in';
                                                }
                                            }
                                        });
                                        $(form)[0].reset();
                                        $('[data-file-remove]').click()
                                    } else {
                                        $.magnificPopup.open({
                                            items: {
                                                src: '#popup-message-error'
                                            },
                                            type: 'inline',
                                            midClick: true,
                                            closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                                            removalDelay: 500, //delay removal by X to allow out-animation
                                            callbacks: {
                                                beforeOpen: function() {
                                                    this.st.mainClass = 'mfp-zoom-in';
                                                }
                                            }
                                        });
                                    }

                                    if ($('[data-preloader]').length > 0) {
                                        $('[data-preloader]').hide();
                                    }
                                }
                            })
                        } else if ($(form).find('[data-hidden-confirm]').length > 0) {
                            $(form).find('[data-hidden-confirm]').trigger('click');

                            if ($('[data-preloader]').length > 0) {
                                $('[data-preloader]').hide();
                            }
                        } else if ($(form).find('[data-popup-recovery-submit]').length > 0) {
                            $(form).find('[data-hidden-confirm]').trigger('click');

                            if ($('[data-preloader]').length > 0) {
                                $('[data-preloader]').hide();
                            }
                        } else if ($(form).find('[data-product-btn]').length > 0) {
                            event.preventDefault();

                            /**
                             * Выполняеся в www/local/blocks/j-jamilco-catalog/j-jamilco-catalog.js
                             * @type {*|NodeJS.Global.jQuery}
                             */
                            let sizeBtn = $(form).find('[data-product-size]');
                            let error = sizeBtn.prev();
                            if (sizeBtn.find('.active').length < 1) {
                                let header = $('[data-header-sticky]').innerHeight();
                                let top = sizeBtn.offset().top - header - 100;

                                $('html, body').animate({scrollTop: `${top}px`}, 500);

                                setTimeout(() => {
                                    error.fadeIn('slow')
                                }, 500);
                            } else {
                                error.fadeOut('slow')
                            }

                            if ($('[data-preloader]').length > 0) {
                                $('[data-preloader]').hide();
                            }
                        } else {
                            form.submit();

                            if ($('[data-preloader]').length > 0) {
                                $('[data-preloader]').hide();
                            }
                        }
                    }

                    $('body').removeClass('body--loading');

                    return false;
                }
            });
        });

        // Модификация classRules
        $.validator.addClassRules = function(className, rules) {
            if (className.constructor === String) {
                var obj = {};
                obj[className] = rules;
                className = obj;
            }
            $.each(className, function(n, r) {
                $("." + n).each(function(i, e) {
                    var self = $(e)
                    self.rules('add', r);
                });
            });
        };

        $.extend($.validator.messages, {
            required: "Пожалуйста, заполните поле",
            remote: "Исправьте это поле чтобы продолжить",
            email: "Введите правильный email адрес",
            url: "Введите верный URL",
            date: "Введите правильную дату",
            dateISO: "Введите правильную дату (ISO)",
            number: "Введите число",
            digits: "Введите только цифры",
            creditcard: "Введите правильный номер вашей кредитной карты",
            equalTo: "Повторите ввод значения еще раз",
            accept: "Пожалуйста, введите значение с правильным расширением",
            maxlength: $.validator.format("Не более {0} символов"),
            minlength: $.validator.format("Минимальное количество символов {0}"),
            rangelength: $.validator.format("Введите значения от {0} до {1}"),
            range: $.validator.format("Введите значение между {0} и {1}"),
            max: $.validator.format("Введите значение меньше {0}"),
            min: $.validator.format("введите значение больше {0}")
        });

        // Добавление правил на классы
        $.validator.addClassRules({
            'js-valid-name': {
                required: true,
                minlength: 2,
                maxlength: 255,
                regex: /^[а-яёА-ЯЁa-zA-Z]+.*$/,
                messages: {
                    regex: "Некорректные данные",
                    minlength: 'Короткое имя'
                }
            },
            'js-valid-surname': {
                required: true,
                minlength: 2,
                maxlength: 255,
                regex: /^[а-яёА-ЯЁa-zA-Z]+.*$/,
                messages: {
                    regex: "Некорректные данные",
                    minlength: 'Короткая фамилия'
                }
            },
            'js-valid-surname-reg': {
                required: false,
                minlength: 2,
                maxlength: 255,
                regex: /^[а-яёА-ЯЁa-zA-Z]*$/,
                messages: {
                    regex: "Некорректные данные",
                    minlength: 'Короткая фамилия'
                }
            },
            'js-valid-patronymic': {
                required: true,
                minlength: 2,
                regex: /^[а-яёА-ЯЁa-zA-Z]+.*$/,
                messages: {
                    regex: "Некорректные данные",
                    minlength: 'Короткое отчество'
                }
            },
            'js-valid-patronymic-reg': {
                required: false,
                minlength: 2,
                regex: /^[а-яёА-ЯЁa-zA-Z\- ]*$/,
                messages: {
                    regex: "Некорректные данные",
                    minlength: 'Короткое отчество'
                }
            },
            'js-valid-fio': {
                required: true,
                minlength: 3,
                maxlength: 255,
                messages: {
                    minlength: 'Короткое имя'
                }
            },
            'js-valid-header': {
                required: true,
                minlength: 5,
                messages: {
                    minlength: 'Короткий заголовок'
                }
            },
            'js-valid-string': {
                required: true
            },
            'js-valid-city': {
                required: true,
                messages: {
                    required: "Пожалуйста, выберите город"
                }
            },
            'js-valid-email': {
                required: true,
                email: true,
                normalizer: function(value) {
                    return $.trim(value);
                },
                messages: {
                    email: 'Некорректные данные'
                }
            },
            'js-valid-phone': {
                required: true,
                phone: true,
                messages: {
                    phone: 'Некорректные данные',
                    required: 'Пожалуйста, введите номер телефона'
                }
            },
            'js-required-true': {
                required: true,
            },
            'js-valid-tel': {
                required: false,
                regex: /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/,
                messages: {
                    regex: 'Некорректные данные',
                    required: 'Пожалуйста, введите номер телефона'
                }
            },
            'js-valid-required-number': {
                required: true,
                regex: /^\d+$/,
                messages: {
                    regex: "Пожалуйста, введите только цифры"
                }
            },
            'js-valid-number': {
                required: false,
                regex: /^\d+$/,
                messages: {
                    regex: "Пожалуйста, введите только цифры"
                }
            },
            'js-valid-card': {
                required: true,
                regex: /^\d+$/,
                // minlength: 8,
                // maxlength: 12,
                bonusCardEqual: true,
                messages: {
                    regex: "Пожалуйста, введите только цифры",
                    // minlength: "Пожалуйста, введите 8 символов",
                    // maxlength: "Пожалуйста, введите 12 символов",
                    bonusCardEqual: "Введите пожалуйста от 8 до 13 символов"
                }
            },
            'js-valid-card-no-req': {
                required: false,
                regex: /^\d*$/,
                bonusCardEqualEmpty: true,
                messages: {
                    regex: 'Пожалуйста, введите только цифры',
                    bonusCardEqualEmpty: 'Введите пожалуйста от 8 до 13 символов'
                }
            },
            'js-valid-pin': {
                required: true,
                regex: /^\d+$/,
                minlength: 4,
                maxlength: 4,
                password: false,
                messages: {
                    regex: "Пожалуйста, введите только цифры",
                    minlength: "Пожалуйста, введите 4 символа",
                    maxlength: "Пожалуйста, введите 4 символа"
                }
            },
            'js-valid-email-pin': {
                required: true,
                regex: /^\d+$/,
                minlength: 5,
                maxlength: 5,
                password: false,
                messages: {
                    regex: "Пожалуйста, введите только цифры",
                    minlength: "Пожалуйста, введите 5 символов",
                    maxlength: "Пожалуйста, введите 5 символов"
                }
            },
            'js-valid-code': {
                required: true,
                regex: /^\d+$/,
                minlength: 5,
                maxlength: 5,
                password: false,
                messages: {
                    regex: "Пожалуйста, введите только цифры",
                    minlength: "Пожалуйста, введите 5 символов",
                    maxlength: "Пожалуйста, введите 5 символов"
                }
            },
            'js-valid-zip': {
                required: true,
                regex: /^\d+$/,
                minlength: 6,
                maxlength: 6,
                messages: {
                    regex: "Пожалуйста, введите только цифры",
                    minlength: "Пожалуйста, введите 6 символов",
                    maxlength: "Пожалуйста, введите 6 символов",
                }
            },
            'js-valid-adress': {
                required: true
            },
            'js-valid-check': {
                required: true,
                messages: {
                    required: 'Пожалуйста, подтвердите ваше согласие'
                }
            },
            'js-valid-pass': {
                required: true,
                pass: true,
                notEqual: ".js-valid-old-pass",
                messages: {
                    notEqual: "Новый пароль должен отличаться от старого"
                }
            },
            'js-valid-pass-edit': {
                required: false,
                passEmpty: true,
                notEqual: ".js-valid-old-pass",
                messages: {
                    notEqual: "Новый пароль должен отличаться от старого"
                }
            },
            'js-valid-pass-confirm': {
                required: true,
                equalTo: $('.js-valid-pass-confirm').closest('[data-validate]').find('.js-valid-pass'),
                messages: {
                    equalTo: "Пароли не совпадают"
                }
            },
            'js-valid-pass-confirm-edit': {
                required: false,
                equalTo: $('.js-valid-pass-confirm-edit').closest('[data-validate]').find('.js-valid-pass-edit'),
                messages: {
                    equalTo: "Пароли не совпадают"
                }
            },
            'js-valid-date': {
                required: true,
                messages: {
                    required: 'Пожалуйста, введите дату рождения',
                }
            },
            'js-valid-order-id': {
                required: true,
                regex: /^\d+$/,
                maxlength: 10,
                messages: {
                    regex: "Пожалуйста, введите только цифры",
                }
            },
            'js-valid-select': {
                valueNotEquals: "default",
                validDate: true,
                messages: {
                    valueNotEquals: "Пожалуйста, выберите значение",
                    validDate: "Выбрана некоректная дата"
                }
            }
        });

        var tel = document.querySelectorAll("[type='tel']");
        Inputmask({
            "mask": "+7 (999) 999[-99][-99]",
            regex: /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/,
            "clearMaskOnLostFocus": true,
            "placeholder": '',
            "showMaskOnHover": false,
            "showMaskOnFocus": true,
            "greedy": false,
            inputmode: 'tel',
            onBeforePaste: function(pastedValue) {
                let trimmedPastedValue = pastedValue.trim()
                if (trimmedPastedValue.length > 10 && (trimmedPastedValue[0] === '8' || trimmedPastedValue[0] === '7')) {
                    return trimmedPastedValue.slice(1);
                }
                return trimmedPastedValue
            },
        }).mask(tel);

        var date = document.querySelectorAll('.date-input');
        Inputmask({
          alias: 'datetime',
          inputFormat: 'dd/mm/yyyy',
          clearMaskOnLostFocus: true,
          placeholder: '',
          showMaskOnHover: false,
          showMaskOnFocus: true,
          greedy: false,
        }).mask(date);

        $("input[type=number], [data-input-number]").on('keyup', function(e) {
            this.value = this.value.replace(/[^0-9\.]/g, '');
        });
    }

    showCodeCard(_block, _card, _contact)
    {
        _block.find('[data-send-card]').addClass('d-none');
        _block.find('[data-send-card-button]').addClass('d-none');
        _block.find('[data-send-pin]').removeClass('d-none');
        _block.find('[data-send-pin-button]').removeClass('d-none');
        _block.find('[data-add-bonus-card]').remove();

        if (_contact['PHONE'] > '') {
            _block.find('.card-phone-if').removeClass('hidden');
            _block.find('.card-phone').text(_contact['PHONE']);
        } else {
            _block.find('.card-phone-if').addClass('hidden');
        }

        if (_contact['EMAIL'] > '') {
            _block.find('.card-email-if').removeClass('hidden');
            _block.find('.card-email').text(_contact['EMAIL']);
        } else {
            _block.find('.card-email-if').addClass('hidden');
        }

        if (_contact['EMAIL'] > '' || _contact['PHONE'] > '') {
            _block.find('.card-contact-no').addClass('hidden');
        } else {
            _block.find('.card-contact-no').removeClass('hidden');
        }

    }


}

export {Form};

$(window).on('load', () => {
    let form = new Form();

    window.Form = Form;
})
